// Mixin for EnrollmentForm to reduce duplication
import { mapActions, mapGetters } from "vuex";

import CustomForm from "@Shared/components/CustomForm";

export default {
  components: {
    CustomForm
  },
  data() {
    return {
      validation: {},
      activeForms: [],
      lastActivated: ""
    };
  },
  activated() {
    this.setActiveForms(this.activeForms);
    this.lastActivated = +new Date();
  },
  computed: {
    ...mapGetters({ getFormValues: "formValues" }),
    formValues: {
      get() {
        return this.getFormValues;
      },
      set(val) {
        this.setFormValues(val);
      }
    },
    valid() {
      return Object.entries(this.validation).reduce((acc, [key, val]) => {
        return acc && !val.$invalid;
      }, true);
    }
  },
  watch: {
    valid(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("valid-change", newVal);
      }
    },
    activeForms: {
      handler(val) {
        this.setActiveForms(val);
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(["setFormErrors", "setActiveForms", "setFormValues"]),
    handleValidChange(formName, validation) {
      this.validation = {
        ...this.validation,
        [formName]: validation
      };
    },
    handleCustomFormInput(formName, val) {
      this.formValues = {
        ...this.formValues,
        [formName]: val
      };
    },
    handleErrorsChange(formName, errors) {
      this.setFormErrors({ formName, errors });
    },
    touch() {
      for (let i = 0; i < this.activeForms.length; i++) {
        this.$refs[this.activeForms[i]].touch();
      }
    },
    reset() {
      for (let i = 0; i < this.activeForms.length; i++) {
        this.$refs[this.activeForms[i]].reset();
      }
    }
  }
};
